import { useState } from "react";

const eventTypes = ["Private Dinner", "Luxury Event", "Bespoke Hospitality", "Table Styling", "Corporate Hosting", "Other"];
const budgetRanges = ["£5,000 – £10,000", "£10,000 – £25,000", "£25,000 – £50,000", "£50,000+", "Prefer not to say"];

export default function InquiryForm() {
  const [submitted, setSubmitted] = useState(false);
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const params = new URLSearchParams();
    data.forEach((val, key) => params.append(key, val.toString()));
    try {
      await fetch("https://readdy.ai/api/form/d7du35em3fsfopf241u0", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString()
      });
    } finally {
      setSubmitted(true);
    }
  };

  return (
    <section className="bg-[#0D0D0D] py-36 px-8 md:px-16">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#C9A961] tracking-[0.3em] text-xs uppercase font-light mb-6">Exclusively Tailored</p>
          <h2 className="font-serif text-[#FAF8F5] text-4xl md:text-5xl font-normal mb-4">Begin Your Inquiry</h2>
          <p className="text-[#8A7F74] text-sm font-light leading-relaxed">
            Share your vision, and we will craft an experience to surpass it.
          </p>
        </div>

        {submitted ? (
          <div className="text-center py-20 border border-[#2A2A2A] rounded-lg">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-6">
              <i className="ri-check-line text-3xl text-[#C9A961]" />
            </div>
            <h3 className="font-serif text-[#FAF8F5] text-2xl mb-3">Thank you.</h3>
            <p className="text-[#8A7F74] text-sm font-light">We have received your inquiry and will be in touch within 24 hours.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form id="table-prive-inquiry" className="space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Full Name *</label>
                <input name="name" type="text" required placeholder="Your name" className="w-full bg-transparent border border-[#2A2A2A] text-[#FAF8F5] placeholder-[#3A3A3A] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors" />
              </div>
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Email Address *</label>
                <input name="email" type="email" required placeholder="your@email.com" className="w-full bg-transparent border border-[#2A2A2A] text-[#FAF8F5] placeholder-[#3A3A3A] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors" />
              </div>
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Phone Number</label>
                <input name="phone" type="tel" placeholder="+44 000 000 0000" className="w-full bg-transparent border border-[#2A2A2A] text-[#FAF8F5] placeholder-[#3A3A3A] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors" />
              </div>
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Event Type</label>
                <select name="event_type" className="w-full bg-[#1A1A1A] border border-[#2A2A2A] text-[#8A7F74] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors cursor-pointer appearance-none">
                  <option value="">Select type</option>
                  {eventTypes.map(t => <option key={t} value={t}>{t}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Preferred Date</label>
                <input name="date" type="date" className="w-full bg-transparent border border-[#2A2A2A] text-[#8A7F74] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors" />
              </div>
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Location</label>
                <input name="location" type="text" placeholder="City or venue" className="w-full bg-transparent border border-[#2A2A2A] text-[#FAF8F5] placeholder-[#3A3A3A] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors" />
              </div>
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Number of Guests</label>
                <input name="guests" type="number" min="1" placeholder="e.g. 12" className="w-full bg-transparent border border-[#2A2A2A] text-[#FAF8F5] placeholder-[#3A3A3A] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors" />
              </div>
              <div>
                <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">Budget Range</label>
                <select name="budget" className="w-full bg-[#1A1A1A] border border-[#2A2A2A] text-[#8A7F74] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors cursor-pointer appearance-none">
                  <option value="">Select range</option>
                  {budgetRanges.map(b => <option key={b} value={b}>{b}</option>)}
                </select>
              </div>
            </div>

            <div>
              <label className="block text-[#8A7F74] text-xs tracking-[0.15em] uppercase font-light mb-2">
                Your Vision / Notes
                <span className="ml-2 text-[#3A3A3A] normal-case tracking-normal">({charCount}/500)</span>
              </label>
              <textarea
                name="vision"
                rows={5}
                maxLength={500}
                placeholder="Describe your ideal experience — the atmosphere, the occasion, any specific wishes..."
                onChange={(e) => setCharCount(e.target.value.length)}
                className="w-full bg-transparent border border-[#2A2A2A] text-[#FAF8F5] placeholder-[#3A3A3A] px-4 py-3.5 text-sm font-light focus:outline-none focus:border-[#C9A961] transition-colors resize-none"
              />
            </div>

            <div className="pt-4">
              <button
                type="submit"
                className="w-full py-4 bg-[#C9A961] text-[#1A1A1A] text-sm tracking-[0.2em] uppercase font-light hover:bg-[#E8DCC8] transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Submit Private Inquiry
              </button>
              <p className="text-center text-[#3A3A3A] text-xs font-light mt-4 tracking-wide">
                All inquiries are handled with complete discretion and confidentiality.
              </p>
            </div>
          </form>
        )}
      </div>
    </section>
  );
}
